<template>
    <b-card no-body>
        <v-table
            ref="table"
            :items-provider="provider"
            pagination="server"
            :fields="fields"
            search
            :buttons="buttons"
        />
        <b-modal id="supplier-detail-modal" size="lg" title="Firma Detayı" ok-only ok-title="Kapat" no-close-on-esc no-close-on-backdrop>
            <fuel-supplier-detail :supplier="selectedSupplier" />
                <template #modal-footer>
                    <div> </div>
                </template>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import FirmOperationsApi from '@/api/firm-operations';
import FuelSupplierDetail from './components/FuelSupplierDetail.vue';

export default {
    name: 'FuelSupplierView',
    components: {
        BCard,
        FuelSupplierDetail
    },
    data() {
        return {
            selectedSupplier: null,
            fields: [
                { name: 'Firma Adı', key: 'Name', thClass:'w-40'},
                { name: 'Ana Firma', key: 'ParentFirmName', thClass:'w-30'},
                { name: 'Vergi Numarası', key: 'TaxNumber', thClass:'w-30'},
            ],
            buttons: [
            { text: "Detay", key: "detail", icon: "EyeIcon", variant: "info", action: this.showDetails },
            ],
        };
    },
    methods: {
        provider(data) {
            const requestPayload = {
                PaginationRequestModel: data,
                FirmRole: 5
            };
            return FirmOperationsApi.Table(requestPayload);
        },
        showDetails(item) {
            this.selectedSupplier = item;
            this.$showModal('supplier-detail-modal');
        }
    }
};
</script>
